import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the user clicks "Invite" from the Invite Recommendation popup
 * Event: dental_portal:invite_recommendation:invite_clicked
 */
export function fireInviteRecommendationInviteClicked(): void {
  PosthogService.getInstance().track('dental_portal:invite_recommendation:invite_clicked', {
    invite_type: 'Existing Shift',
  });
}
